import React from "react";
import LayerElement, { layerType } from "./layer-element/layer-element";
import TerrainControl from "./layer-element/terrain-control";
import PropTypes from 'prop-types';
import styles from './layers-control.module.css'

export default function LayersControl({
    layers,
    layersCollapsed,
    setLayers,
    updateLayerVisible,
    updateLayerOpacity,
    changeLayer,
    callbackFunction,

    terrain,
    setTerrain,
    setTerrainProvider
}) {
    const changeChildrenLayersVisible = (layer, visible, callbackFunct) => {
        let newLayer = {
            ...layer,
            visible: visible
        };
        let cb = callbackFunct;
        if (layer.type) {
            newLayer.loading = true;
            cb = () => { callbackFunct(); updateLayerVisible(newLayer); };
        }
        if (layer.elements)
            newLayer.elements = layer.elements.map(e => {
                let [l, p] = changeChildrenLayersVisible(e, visible, cb);
                cb = p;
                return l;
            });
        return [newLayer, cb];
    };
    const changeLayerVisible = (layer, parents) => {
        let [newLayer, callbackFunct] = changeChildrenLayersVisible(layer, !layer.visible, () => { });
        let p, updatedElement;
        while ((p = parents.pop()) !== undefined) {
            updatedElement = {
                ...p,
                visible: undefined
            };
            updatedElement.elements[updatedElement.elements.findIndex(e => e.id === newLayer.id)] = newLayer;
            updatedElement.visible = undefined;
            updatedElement.elements.forEach(e => {
                if (updatedElement.visible === undefined)
                    updatedElement.visible = e.visible;
                else if (updatedElement.visible !== e.visible)
                    updatedElement.visible = null;
            });
            if (updatedElement.type)
                updatedElement.loading = true;
            newLayer = updatedElement;
            let cb = callbackFunct;
            callbackFunct = () => { cb(); updateLayerVisible(updatedElement); };
        }
        let newLayers = [...layers];
        newLayers[newLayers.findIndex((e) => e.id === newLayer.id)] = newLayer;
        callbackFunction.current = callbackFunct;
        setLayers(newLayers);
    };

    return (
        <div className={`${styles.container} ${layersCollapsed ? styles.collapsed : ''}`}>
            <TerrainControl
            terrain={terrain}
            setTerrain={setTerrain}
            setTerrainProvider={setTerrainProvider}
            callbackFunction={callbackFunction}
            />           
            <div>
                {layers.map((layer) => (
                    <LayerElement
                        key={layer.id}
                        layer={layer}
                        changeLayerVisible={changeLayerVisible}
                        changeLayer={changeLayer}
                        updateLayerOpacity={updateLayerOpacity}
                        callbackFunction={callbackFunction}
                    />
                ))}
            </div>
        </div>
    );
}

LayersControl.propTypes = {
    layers: PropTypes.arrayOf(layerType).isRequired,
    layersCollapsed: PropTypes.bool.isRequired,
    setLayers: PropTypes.func.isRequired,
    updateLayerVisible: PropTypes.func.isRequired,
    updateLayerOpacity: PropTypes.func.isRequired,
    changeLayer: PropTypes.func.isRequired,
    callbackFunction: PropTypes.object.isRequired,
    terrain: layerType.isRequired,
    setTerrain: PropTypes.func.isRequired,
    setTerrainProvider: PropTypes.func.isRequired,
};